<template>
  <div :class="rootClasses" data-pc-name="splitter" :data-p-resizing="false">
    <slot></slot>
  </div>
</template>

<script>
import BaseSplitter from "./BaseSplitter.vue";

export default {
  name: "SplitterCustom",
  mixins: [BaseSplitter],
  mouseMoveListener: null,
  mouseUpListener: null,
  panelSizes: null,
  data() {
    return {
      allChildren: null
    };
  },
  mounted() {
    this.setupPanelLayout();
  },
  methods: {
    setupPanelLayout() {
      this.allChildren = this.$children;

      if (this.panels && this.panels.length) {
        let initialized = false;
        if (this.isStateful()) {
          initialized = this.restoreState();
        }

        if (!initialized) {
          let children = [...this.$el.children].filter(
            child => child.getAttribute("data-pc-name") === "splitterpanel"
          );
          let _panelSizes = [];

          this.panels.map((panel, i) => {
            let panelInitialSize = panel && panel.size ? panel.size : null;
            let panelSize = panelInitialSize || 100 / this.panels.length;

            _panelSizes[i] = panelSize;
            children[i].style.flexBasis =
              "calc(" +
              panelSize +
              "% - " +
              (this.panels.length - 1) * this.gutterSize +
              "px)";
            this.$emit("onContext", this);
          });

          this.panelSizes = _panelSizes;
        }
      }
    },
    isStateful() {
      return this.stateKey != null;
    },
    restoreState() {
      const storage = this.getStorage();
      const stateString = storage.getItem(this.stateKey);

      if (stateString) {
        this.panelSizes = JSON.parse(stateString);
        let children = [...this.$el.children].filter(
          child => child.getAttribute("data-pc-name") === "splitterpanel"
        );
        children.forEach((child, i) => {
          child.style.flexBasis =
            "calc(" +
            this.panelSizes[i] +
            "% - " +
            (this.panels.length - 1) * this.gutterSize +
            "px)";
        });

        return true;
      }

      return false;
    }
  },
  computed: {
    panels() {
      let panels = [];
      if (this.allChildren) {
        panels = this.allChildren.filter(
          child => child.$vnode.tag.indexOf("SplitterPanel") !== -1
        );
      }
      return panels;
    },
    gutterStyle() {
      if (this.horizontal) return { width: this.gutterSize + "px" };
      else return { height: this.gutterSize + "px" };
    },
    horizontal() {
      return this.layout === "horizontal";
    }
  }
};
</script>
